import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { DeliveryProps, FetchDeliveries, checkedItems } from '../../types'
import { useAllDeliveries } from '../../graphql'
import OrdersTable from '../../components/Tables/OrdersTable'
import DeleteConfirmPopup from './DeleteConfirmPopup'
import SuccessAlert from '../../components/Alerts/SuccessAlert'
import FailAlert from '../../components/Alerts/FailAlert'
import LoadingWidget from '../../components/LoadingWidget/LoadingWidget'
import useStore from '../../store/useStore'
import { AiOutlineAppstoreAdd } from 'react-icons/ai'
import { BsFilter } from 'react-icons/bs'
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs'
import { t } from 'i18next';
import { IoArrowBackSharp, IoArrowForward } from 'react-icons/io5'
import { IoMdPrint } from 'react-icons/io'
import html2pdf from 'html2pdf.js';

interface Props {
  direction: string
}

const Orders = ({ direction }: Props) => {
  const storeData = useStore((state: any) => state.userData.store);
  const userData = useStore((state: any) => state.userData);

  const [permissions, setPermissions] = useState({
    create: false,
    view: false,
    delete: false,
  })

  // Permission configuration
  useEffect(() => {
    if (Object.keys(userData).length !== 0) {
      // admin
      if (userData.permissions.length === 0 && userData.role === "admin") {
        setPermissions({
          create: true,
          view: true,
          delete: true,
        })

        return
      }

      const filtered = userData?.permissions?.filter((perm: { name: string }) => perm.name === "orders")

      let createPermission = filtered[0]?.permissions.includes("create")
      let viewPermission = filtered[0]?.permissions.includes("view")
      let deletePermission = filtered[0]?.permissions.includes("delete")

      setPermissions({
        create: createPermission || false,
        view: viewPermission || false,
        delete: deletePermission || false,
      })
    }
  }, [userData])

  // The state that contains Fetched Orders, i didn't use dataAllDeliveries from useAllDeliveries beacuse i couldn't modify it to contain filtered result
  const [Deliveries, setDeliveries] = useState<FetchDeliveries>();

  // This state hook is to specify which item going to start from in the table
  const [startingIndex, setStartingIndex] = useState(0)

  // i had to use a main state for control loading because of ui issues
  const [initialLoading, setInitialLoading] = useState(true);

  const [allDeliveries, { loading, data: dataAllDeliveries }] = useAllDeliveries();

  useEffect(() => {
    storeData &&
      (async () => {
        await allDeliveries({
          variables: { idStore: storeData.id }
        })

        setInitialLoading(false)
      })()
  }, [storeData]);

  useEffect(() => {
    storeData && dataAllDeliveries !== undefined && setDeliveries(dataAllDeliveries)
  }, [dataAllDeliveries, storeData]);

  // Alerts
  const [success, setSuccess] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [fail, setFail] = useState(false);
  const [failMsg, setFailMsg] = useState("");

  const [FilterDropDown, setFilterDropDown] = useState(false);

  const [PaymentFilterDropDown, setPaymentFilterDropDown] = useState(false);
  const [PaymentFilterQuery, setPaymentFilterQuery] = useState("");
  const [ShippingFilterDropDown, setShippingFilterDropDown] = useState(false);
  const [ShippingFilterQuery, setShippingFilterQuery] = useState("");

  const [deleteConfPopup, setDeleteConfPopup] = useState(false);
  // This state contains the id of the client that will be deleted
  const [selectedIdForDelete, setSelectedIdForDelete] = useState("");

  // Search functionality
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResult, setSearchResult] = useState<DeliveryProps[] | undefined>([]);

  useEffect(() => {
    const filtered = dataAllDeliveries?.allDeliveries.filter(order =>
      order.orderNumber.toLowerCase().includes(searchQuery.toLowerCase())
    );

    setSearchResult(filtered);
  }, [searchQuery, dataAllDeliveries]);

  let uniquePayment: any[] = [];

  // Find the available payment Methods
  if (storeData) {
    const uniquePaymentSet = new Set(dataAllDeliveries?.allDeliveries.map(order => order?.paymentMethod !== null && order.paymentMethod.bankName));
    uniquePayment = Array.from(uniquePaymentSet);
  }

  // Find the available shipping Methods
  const uniqueShippingSet = new Set(dataAllDeliveries?.allDeliveries.map(order => order?.deliveryMethod !== null && order.deliveryMethod.name));
  const uniqueShipping = Array.from(uniqueShippingSet);

  useEffect(() => {
    if (PaymentFilterQuery !== "" && dataAllDeliveries !== undefined) {
      const filtered = dataAllDeliveries?.allDeliveries.filter(item =>
        item.paymentMethod.bankName.toLowerCase().includes(PaymentFilterQuery.toLowerCase())
      );

      setDeliveries({ allDeliveries: filtered });
    }
  }, [PaymentFilterQuery, dataAllDeliveries])

  useEffect(() => {
    if (ShippingFilterQuery !== "" && dataAllDeliveries !== undefined) {
      const filtered = dataAllDeliveries?.allDeliveries.filter(item =>
        item.deliveryMethod.name === ShippingFilterQuery
      );

      setDeliveries({ allDeliveries: filtered });
    }
  }, [ShippingFilterQuery, dataAllDeliveries]);

  const clearFilters = () => {
    dataAllDeliveries !== undefined && setDeliveries(dataAllDeliveries)
    setPaymentFilterQuery("");
    setShippingFilterQuery("");
  }

  const [checkedItems, setCheckedItems] = useState<checkedItems[]>([]);

  const downloadPDF = () => {
    // Retrieve your dynamic data from the API or other source

    let dynamicData: any = []

    if (checkedItems.length !== 0) {
      dataAllDeliveries?.allDeliveries.forEach(delivery => {
        if (checkedItems.find(check => delivery.id === check.id)) {
          dynamicData.push({
            number: delivery.orderNumber,
            name: delivery.client.name,
            address: delivery.addressClient.city,
            date: new Date(delivery.createdAt).toLocaleString(undefined, { year: 'numeric', month: '2-digit', day: '2-digit' }),
            total: delivery.deliveryMethod ?
              delivery?.deliveryMethod?.price + delivery?.deliveryProduct?.reduce(
                (accumulator, product: any) => accumulator + (product?.price - delivery?.discount) * product?.quantity, 0
              )
              :
              delivery?.deliveryProduct?.reduce(
                (accumulator, product: any) => accumulator + (product?.price - delivery?.discount) * product?.quantity, 0
              )
          })
        }
      })

    } else {
      dynamicData = dataAllDeliveries?.allDeliveries.map(delivery => (
        {
          number: delivery.orderNumber,
          name: delivery.client.name,
          address: delivery.addressClient.city,
          date: new Date(delivery.createdAt).toLocaleString(undefined, { year: 'numeric', month: '2-digit', day: '2-digit' }),
          total: delivery.deliveryMethod ?
            delivery?.deliveryMethod?.price + delivery?.deliveryProduct?.reduce(
              (accumulator, product: any) => accumulator + (product?.price - delivery?.discount) * product?.quantity, 0
            )
            :
            delivery?.deliveryProduct?.reduce(
              (accumulator, product: any) => accumulator + (product?.price - delivery?.discount) * product?.quantity, 0
            )
        }
      ))
    }

    // Create a new table element
    const newTable = document.createElement('table');
    newTable.classList.add("table", "w-full", "divide-y", "divide-gray-200");

    // Create the table header
    const headerRow = newTable.insertRow();
    headerRow.classList.add("bg-gray-50", "divide-gray-200");
    Object.keys(dynamicData[0]).forEach((key) => {
      const th = document.createElement('th');
      th.textContent = key;
      th.classList.add("px-3", "py-3", "text-sm", "font-semibold", "text-left", "text-gray-500", "whitespace-nowrap", "rtl:text-right");
      headerRow.appendChild(th);
    });

    // Create the table body
    dynamicData.forEach((rowData: any) => {
      const row = newTable.insertRow();
      Object.values(rowData).forEach((value) => {
        const cell = row.insertCell();
        // @ts-ignore
        cell.textContent = value;
        cell.classList.add("px-3", "border-b", "py-3", "text-sm")
      });
    });

    // Use html2pdf to generate PDF from the new table
    new html2pdf(newTable, {
      filename: 'orders.pdf', // Replace 'custom_filename' with your desired filename
    });
  };

  return (
    <section className='mx-3 my-4 md:mx-7'>
      {success && <SuccessAlert success={success} setSuccess={setSuccess} successMsg={successMsg} />}

      {fail && <FailAlert fail={fail} setFail={setFail} failMsg={failMsg} />}

      {deleteConfPopup && <DeleteConfirmPopup checkedItems={checkedItems} setDeleteConfPopup={setDeleteConfPopup} selectedIdForDelete={selectedIdForDelete} setSuccess={setSuccess} setSuccessMsg={setSuccessMsg} />}

      <div className='flex flex-col-reverse md:flex-row md:justify-between md:items-center'>
        <div>
          <h3 className='text-2xl font-semibold'>{t('orders')}</h3>
        </div>
        <div>
          <Breadcrumbs />
        </div>
      </div>

      {initialLoading || loading ?
        <LoadingWidget />
        :
        <div className='p-2 mt-3 bg-white rounded-md'>
          <div>
            <div className='my-4 md:flex md:justify-between'>
              <div className='flex items-center gap-2'>
                <div className="relative flex items-center flex-1 w-full h-12 overflow-hidden bg-white border rounded-lg md:w-2/6">
                  <div className="grid w-12 h-full text-gray-300 place-items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                    </svg>
                  </div>

                  <input value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} className="w-full h-full pr-2 text-sm text-gray-700 outline-none" type="text" id="search" placeholder={t('searchSomething')} />
                </div>

                <div onClick={downloadPDF} className='inline-flex items-center justify-center px-4 py-3 overflow-hidden text-gray-400 transition-colors duration-300 bg-transparent border rounded-lg cursor-pointer'>
                  <IoMdPrint size={20} />
                </div>
              </div>

              <div className='gap-3 sm:flex'>

                <button onClick={() => { setFilterDropDown(!FilterDropDown) }} className='inline-flex items-center justify-center w-full px-5 py-3 my-2 overflow-hidden text-white transition-colors duration-300 rounded-lg shadow md:py-0 bg-primary sm:w-auto md:my-0 hover:bg-primaryHover'>
                  <BsFilter size={20} />

                  <span className="mx-2">
                    {t('filter')}
                  </span>
                </button>

                {
                  permissions.create &&
                  <Link to="/orders/create" className='inline-flex items-center justify-center w-full px-4 py-3 my-2 overflow-hidden text-white transition-colors duration-300 rounded-lg shadow md:py-0 bg-primary sm:w-auto md:my-0 hover:bg-primaryHover'>
                    <AiOutlineAppstoreAdd size={20} />

                    <span className="mx-2">
                      {t('addOrder')}
                    </span>
                  </Link>
                }
              </div>
            </div>

            {FilterDropDown &&
              <div>
                <div className='grid grid-cols-2 gap-2'>
                  <div className="relative inline-block">
                    <button onClick={() => { setPaymentFilterDropDown(!PaymentFilterDropDown) }} className="z-10 flex items-center justify-between w-full p-2 text-gray-700 bg-gray-100 border rounded-md focus:outline-none">
                      <span className="mx-1">{t('payment')}</span>
                      <svg className="w-5 h-5 mx-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 15.713L18.01 9.70299L16.597 8.28799L12 12.888L7.40399 8.28799L5.98999 9.70199L12 15.713Z" fill="currentColor"></path>
                      </svg>
                    </button>

                    {PaymentFilterDropDown &&
                      <div className="absolute right-0 z-20 w-full max-h-[270px] overflow-auto py-2 mt-2 origin-top-right bg-white border rounded-md shadow-xl">
                        {uniquePayment.map((payment: any, index) => (
                          <span key={index} onClick={() => { setPaymentFilterQuery(payment); setPaymentFilterDropDown(false) }} className="block px-4 py-3 text-sm text-gray-600 capitalize transition-colors duration-300 transform cursor-pointer hover:bg-gray-100">
                            {payment}
                          </span>
                        ))}
                      </div>
                    }
                  </div>

                  <div className="relative inline-block">
                    <button onClick={() => { setShippingFilterDropDown(!ShippingFilterDropDown) }} className="z-10 flex items-center justify-between w-full p-2 text-gray-700 bg-gray-100 border rounded-md focus:outline-none">
                      <span className="mx-1">{t('shipping')}</span>
                      <svg className="w-5 h-5 mx-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 15.713L18.01 9.70299L16.597 8.28799L12 12.888L7.40399 8.28799L5.98999 9.70199L12 15.713Z" fill="currentColor"></path>
                      </svg>
                    </button>

                    {ShippingFilterDropDown &&
                      <div className="absolute right-0 z-20 w-full max-h-[270px] overflow-auto py-2 mt-2 origin-top-right bg-white border rounded-md shadow-xl">
                        {uniqueShipping.map((shipping: any, index) => (
                          <span key={index} onClick={() => { setShippingFilterQuery(shipping); setShippingFilterDropDown(false) }} className="block px-4 py-3 text-sm text-gray-600 capitalize transition-colors duration-300 transform cursor-pointer hover:bg-gray-100">
                            {shipping}
                          </span>
                        ))}
                      </div>
                    }
                  </div>
                </div>
                <div className='flex justify-end'>
                  <button onClick={clearFilters} className='px-4 py-3 my-2 overflow-hidden text-sm text-white transition-colors duration-300 rounded-lg shadow bg-primary hover:bg-primaryHover'>
                    {t('clear')}
                  </button>
                </div>
              </div>
            }
          </div>

          <div className='pt-2 overflow-x-scroll' id="yourTableId">
            <OrdersTable checkedItems={checkedItems} setCheckedItems={setCheckedItems} permissions={permissions} direction={direction} searchQuery={searchQuery} searchResult={searchResult} allDeliveries={Deliveries} setSelectedIdForDelete={setSelectedIdForDelete} setDeleteConfPopup={setDeleteConfPopup} setFailMsg={setFailMsg} startingIndex={startingIndex} />
          </div>

          {searchQuery !== "" &&
            searchResult !== undefined &&
            searchResult.length === 0 &&
            <div className='flex w-full p-2 mt-2 text-red-600 bg-red-200'>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M11.953 2C6.465 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.493 2 11.953 2zM12 20c-4.411 0-8-3.589-8-8s3.567-8 7.953-8C16.391 4 20 7.589 20 12s-3.589 8-8 8z"></path>
                <path d="M11 7h2v7h-2zm0 8h2v2h-2z"></path>
              </svg>
              <span className='px-2'>{t('notMatch')}</span>
            </div>
          }

          {dataAllDeliveries?.allDeliveries.length === 0 &&
            <div className='flex w-full p-2 mt-2 text-red-600 bg-red-200'>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M11.953 2C6.465 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.493 2 11.953 2zM12 20c-4.411 0-8-3.589-8-8s3.567-8 7.953-8C16.391 4 20 7.589 20 12s-3.589 8-8 8z"></path>
                <path d="M11 7h2v7h-2zm0 8h2v2h-2z"></path>
              </svg>
              <span className='px-2'>{t('noOrders')}</span>
            </div>
          }

          <div className="flex justify-end gap-1.5 text-gray-500 py-4">
            <span className="font-medium text-gray-700">{startingIndex} - {startingIndex + 10}</span>
            <span>{t('of')} {dataAllDeliveries?.allDeliveries.length} {t('records')}</span>
          </div>

          <div className='flex items-center justify-between'>
            {dataAllDeliveries?.allDeliveries &&
              startingIndex !== 0 &&
              <div className="gap-1.5 text-gray-500 py-2">
                <button onClick={() => setStartingIndex(startingIndex - 10)} className='inline-flex items-center justify-center w-full px-4 py-2.5 overflow-hidden text-sm text-white transition-colors duration-300 bg-primary rounded-lg shadow sm:w-auto my-2 md:my-0 hover:bg-primaryHover'>
                  {direction === "ltr" ? <IoArrowBackSharp size={18} /> : <IoArrowForward size={18} />}
                  <span className="mx-2">
                    {t('prev')}
                  </span>
                </button>
              </div>
            }

            {dataAllDeliveries?.allDeliveries &&
              startingIndex + 10 < dataAllDeliveries?.allDeliveries.length &&
              <div className={`${direction === "ltr" ? "ml-auto" : "mr-auto"} gap-1.5 text-gray-500 py-2`} dir='ltr'>
                <button onClick={() => setStartingIndex(startingIndex + 10)} className='inline-flex items-center justify-center w-full px-4 py-2.5 overflow-hidden text-sm text-white transition-colors duration-300 bg-primary rounded-lg shadow sm:w-auto my-2 md:my-0 hover:bg-primaryHover'>
                  {direction === "ltr" ? <IoArrowForward size={18} /> : <IoArrowBackSharp size={18} />}
                  <span className="mx-2">
                    {t('next')}
                  </span>
                </button>
              </div>
            }
          </div>
        </div>
      }
    </section>
  )
}

export default Orders